// api-scaleup.js - Copy this to your project
const API_BASE_URL = 'https://api.jobeng.ai';

export const scaleUpAPI = {
  // ===== STRATEGY =====
  getStrategicPlans: async () => {
    const res = await fetch(`${API_BASE_URL}/api/data/strategic_plans`);
    return res.json();
  },
  createStrategicPlan: async (data) => {
    const res = await fetch(`${API_BASE_URL}/api/data/strategic_plans`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    });
    return res.json();
  },
  
  // ===== MILESTONES =====
  getMilestones: async () => {
    const res = await fetch(`${API_BASE_URL}/api/data/company_milestones`);
    return res.json();
  },
  
  // ===== INITIATIVES =====
  getInitiatives: async () => {
    const res = await fetch(`${API_BASE_URL}/api/data/strategic_initiatives`);
    return res.json();
  },
  
  // ===== GROWTH METRICS =====
  getGrowthMetrics: async () => {
    const res = await fetch(`${API_BASE_URL}/api/data/growth_metrics`);
    return res.json();
  },
  
  // ===== MARKET ANALYSIS =====
  getMarketAnalysis: async () => {
    const res = await fetch(`${API_BASE_URL}/api/data/market_analysis`);
    return res.json();
  },
  
  // ===== COMPETITOR ANALYSIS =====
  getCompetitorAnalysis: async () => {
    const res = await fetch(`${API_BASE_URL}/api/data/competitor_analysis`);
    return res.json();
  },
  
  // ===== FINANCIAL FORECASTS =====
  getFinancialForecasts: async () => {
    const res = await fetch(`${API_BASE_URL}/api/data/financial_forecasts`);
    return res.json();
  },
  
  // ===== TEAM SCALING =====
  getTeamScalingPlans: async () => {
    const res = await fetch(`${API_BASE_URL}/api/data/team_scaling_plans`);
    return res.json();
  },
};